import {
  DateTimeCriteriaRangeInput,
  DateTimeRestrictionData,
  RuleFormDataAgencyOrGroup,
  TTLOCriteriaForRouteResponse,
  TicketTimeLimitOverrideFormData,
} from '../../../integrated-client/models';

export interface TicketTLOEditorModel extends TicketTimeLimitOverrideFormData {
  agenciesAndGroups?: Array<RuleFormDataAgencyOrGroup> | null;
  dateTimeRestrictionsUI?: DateTimeRestrictionData[] | null | undefined;
  travelDatesUI?: DateTimeCriteriaRangeInput[] | null | undefined;
  enabled?: boolean;
}
export type TicketTLOEditorAllowEdit = {
  allowEdit?: boolean;
};

export interface ITicketTLOEditorData {
  editorData?: TicketTLOEditorModel & TicketTLOEditorAllowEdit;
  validation?: any;
  readyToSave: boolean;
}
export class TicketTLOEditorData implements ITicketTLOEditorData {
  editorData?: TicketTLOEditorModel;
  validation?: any;
  readyToSave: boolean;

  constructor() {
    this.readyToSave = false;
  }
}
